import React from "react";
import { Table, TableBody } from "@mui/material";
import { TransferBreakdownTableAmountRow, TransferBreakdownTableHeaderRow } from "./components/TransferBreakdownRow";
import { blue } from "@mui/material/colors";

export default function PurchaseTransferBreakdownTable({purchaseTransferBreakdownInfo}) {
  return (
    <Table>
      <TableBody>
        <TransferBreakdownTableHeaderRow
          name="買掛集計"
          bgcolor={blue[300]}
        />
        <TransferBreakdownTableAmountRow
          name="(1) 地物税込仕切額合計"
          amount={purchaseTransferBreakdownInfo ? purchaseTransferBreakdownInfo.localPurchasePrice : null}
        />
        <TransferBreakdownTableAmountRow
          name="(2) 地物普通税率対象税込仕切額"
          amount={purchaseTransferBreakdownInfo ? purchaseTransferBreakdownInfo.localPurchasePriceForRegularTax : null}
        />
        <TransferBreakdownTableAmountRow
          name="(3) 旅物経済連税込仕切額合計"
          amount={purchaseTransferBreakdownInfo ? purchaseTransferBreakdownInfo.economicFederationPurchasePrice : null}
        />
        <TransferBreakdownTableAmountRow
          name="(4) 旅物経済連普通税率対象税込仕切額合計"
          amount={purchaseTransferBreakdownInfo ? purchaseTransferBreakdownInfo.economicFederationPurchasePriceForRegularTax : null}
        />
        <TransferBreakdownTableAmountRow
          name="(5) 旅物税込仕切額合計"
          amount={purchaseTransferBreakdownInfo ? purchaseTransferBreakdownInfo.travelPurchasePrice : null}
        />
        <TransferBreakdownTableAmountRow
          name="(6) 旅物普通税込仕切額合計"
          amount={purchaseTransferBreakdownInfo ? purchaseTransferBreakdownInfo.travelPurchasePriceForRegularTax : null}
        />
        <TransferBreakdownTableAmountRow
          name="(7) 販売手数料(税抜)合計"
          amount={purchaseTransferBreakdownInfo ? purchaseTransferBreakdownInfo.totalSalesFee : null}
        />
        <TransferBreakdownTableAmountRow
          name="(8) 運賃(税抜)合計"
          amount={purchaseTransferBreakdownInfo ? purchaseTransferBreakdownInfo.totalShippingFee : null}
        />
        <TransferBreakdownTableAmountRow
          name="(9) その他控除(税抜)合計"
          amount={purchaseTransferBreakdownInfo ? purchaseTransferBreakdownInfo.totalOtherFees : null}
        />
        <TransferBreakdownTableAmountRow
          name="(10) 控除税額合計"
          amount={purchaseTransferBreakdownInfo ? purchaseTransferBreakdownInfo.feesTaxPrice : null}
        />
        <TransferBreakdownTableAmountRow
          name="(11) 差引仕切額"
          amount={purchaseTransferBreakdownInfo ? purchaseTransferBreakdownInfo.netPurchasePrice : null}
        />
      </TableBody>
        
    </Table>
  )
}